<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="资讯分类">
                <div style="background: #ffffff;position:relative;">
                    <div class="btn-condition">
                        <el-tooltip class="item" effect="dark" content="新增分类" placement="top">
                            <el-button  @click="handleAdd()" icon="el-icon-plus" v-permission="'operating.news-categories.add'"></el-button>
                        </el-tooltip>
                    </div>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="ID" prop="id" width="80px"></el-table-column>
                    <el-table-column  label="排序" prop="rank"  width="120px" >
                        <template slot-scope="{row, $index}">
                            <inline-editable-input :value="row.rank" @input="(value) => changeEdit(value, row)"></inline-editable-input>
                        </template>
                    </el-table-column>
                    <el-table-column  label="名称" prop="name"></el-table-column>
                    <el-table-column  label="资讯数量" prop="new_total" width="100px"></el-table-column>
                   
                    <el-table-column label="是否启用" prop="status" width="150px">
                        <template slot-scope="scope">
                            <el-switch active-color="#13ce66" v-model="scope.row.status" active-value='0' inactive-value='1'  @change="status => change(status, scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                    <el-table-column width="220px"  fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope">
                                <el-button size="mini" @click="openEdit(scope.$index, scope.row)" v-permission="'operating.news-categories.edit'"
                                >编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <edit ref="edit" :callback="initData" />
                <add ref="add" :callback="initData" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getCategories,editCategoriesStatus } from '@/service/news'
    import { parseTime } from '@/utils'
    import edit from './component/edit'
    import add from './component/add'
    import InlineEditableInput from "../../../components/inlineEditableInput/index";
    import {editCategoriesSort} from "../../../service/news";
    export default {
        name: "List",
        components: {
            edit,
            add,
            InlineEditableInput
        },
        data () {
            return {
                list: [],
                isLoading: false
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            handleAdd(index, row) {
                this.$refs.add
                && this.$refs.add.open()
            },
            changeEdit (value, row) {
                let old = row.rank;
                row.rank = value;
                if (/^-?\d+$/.test(value) === false || value > 9999 || value < -9999 || value === '-0') {
                    this.$nextTick(_ => {row.rank = old});
                    this.$message({
                        type: 'error',
                        message: '请输入-9999-9999之间的排序数字'
                    });
                    row.rank = old;
                    return
                }
                editCategoriesSort(row.id, {
                    rank: value,
                    site_id: this.permission_siteId
                }).then(_ => {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                }).catch (e => {
                    row.rank = old;
                    this.$message({
                        type: 'error',
                        message: e.message || '修改排序错误'
                    })
                })
                // this.$set(data, 'sort', this.currentEditValue)
                // this.currentEditValue = ''
                // this.currentEditSort = ''
            },
            openEdit(index, row) {
                this.$refs.edit
                && ( Object.assign(this.$refs.edit.info, row))
                && this.$refs.edit.open()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = [];
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                await getCategories({}).then((data) => {
                    let listData = data;
                    for (let i in listData) {
                        let row = listData[i];
                        row.status = row.status.toString()
                    }
                    this.list = listData
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            /** 监听到改变switch */
            change (status, data) {
                let message = '';
                if (status == '1') {
                    message = '禁用后，该分类不能再新增资讯，不影响历史资讯的分类，是否确认？'
                } else {
                    message = '启用后，该分类下可以正常新增资讯，是否确认？'
                }
                this.$confirm(message, '提示').then(_ => {
                    let query = {
                        status : status
                    };
                    editCategoriesStatus(data.id, query).then((data) => {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                    }).catch(err => {
                        this.$message({
                            message: err.message || '修改失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {
                    data.status = status == '1' ? '0' : '1'
                })
            },


        }
    }
</script>

<style scoped>

</style>
